import { render, staticRenderFns } from "./DestinationPhone.vue?vue&type=template&id=2714848a&scoped=true&"
import script from "./DestinationPhone.vue?vue&type=script&lang=js&"
export * from "./DestinationPhone.vue?vue&type=script&lang=js&"
import style0 from "./DestinationPhone.vue?vue&type=style&index=0&id=2714848a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2714848a",
  null
  
)

export default component.exports